<template>
  <div>
    <div
      v-if="
        isProductFlowEnabled && productCategory.productCategories.length > 0
      "
    >
      <carousel-3d
        :controls-visible="true"
        :clickable="true"
        :height="300"
        :key="productCategory.productCategories.length"
      >
        <slide
          v-for="(category, i) in productCategory.productCategories"
          :index="i"
          :key="i"
        >
          <figure>
            <div @click="check(i)">
              <img data-qa="shownProdCategory" v-bind:src="`${category.img_path}`" />
              <div class="checkbox">
                <form>
                  <div style="text-align: right">
                    <input
                      type="checkbox"
                      :id="i"
                      name="check"
                      v-model="category.checked"
                    />
                    <label for="check" @click="check(i)">
                      <span> </span>
                    </label>
                  </div>
                </form>
              </div>
              <h2>{{ category.name }}</h2>

              <figcaption>{{ category.hero_tagline }}</figcaption>
            </div>
          </figure>
        </slide>
      </carousel-3d>
      <!-- <carousel-3d :controls-visible="true" :clickable="true" :height="300">
        <slide class="coverImage" :index="0">
          <div class="checkbox">
            <form>
              <div style="text-align: right;">
                <input type="checkbox" id="check" name="check" value="" />
                <label for="check">
                  <span>
                  </span>
                </label>
              </div>
            </form>
          </div>
          <h2>{{ $t('prodCat_1') }}</h2>
          <figure>
            <figcaption>{{ $t('prodCat_1Exp') }}</figcaption>
          </figure>
        </slide>
        </carousel-3d> -->
    </div>
    <div
      v-if="!isProductFlowEnabled && experience.experienceCategories.length > 0"
    >
      <carousel-3d
        :controls-visible="true"
        :clickable="true"
        :height="300"
        :key="experience.experienceCategories.length"
      >
        <slide
          v-for="(category, i) in experience.experienceCategories"
          :index="i"
          :key="i"
        >
          <figure>
            <div @click="check(i)">
              <img data-qa="shownExpCategory" v-bind:src="`${category.img_path}`" />
              <div class="checkbox">
                <form>
                  <div style="text-align: right">
                    <input
                      type="checkbox"
                      :id="i"
                      name="check"
                      v-model="category.checked"
                    />
                    <label for="check" @click="check(i)">
                      <span> </span>
                    </label>
                  </div>
                </form>
              </div>
              <h2>{{ category.name }}</h2>

              <figcaption>{{ category.hero_tagline }}</figcaption>
            </div>
          </figure>
        </slide>
      </carousel-3d>
      <!-- <carousel-3d :controls-visible="true" :clickable="true" :height="300">
        <slide class="coverImage" :index="0">
          <div class="checkbox">
            <form>
              <div style="text-align: right;">
                <input type="checkbox" id="check" name="check" value="" />
                <label for="check">
                  <span>
                  </span>
                </label>
              </div>
            </form>
          </div>
          <h2>{{ $t('prodCat_1') }}</h2>
          <figure>
            <figcaption>{{ $t('prodCat_1Exp') }}</figcaption>
          </figure>
        </slide>
        </carousel-3d> -->
    </div>
    <!-- <button class="add-btn" @click="$bvModal.show('category-modal')">
      {{ $t('addCategory') }}
    </button> -->
    <b-modal id="category-modal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <!-- {{ $t('subscribeYourPlan') }} -->
      </template>
      <ProductCategoryCreate
        v-if="isProductFlowEnabled"
        :firstProductCreate="true"
        @success-category="showCategory"
      />
      <ExperienceCategoryCreate
        v-else
        :firstProductCreate="true"
        @success-category="showCategory"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import ProductCategoryCreate from '../../pages/ProductCategoryCreate'
import ExperienceCategoryCreate from '../../pages/ExperienceCategoryCreate.vue'

export default {
  components: {
    Carousel3d,
    Slide,
    ProductCategoryCreate,
    ExperienceCategoryCreate,
  },
  data() {
    return {
      slides: 6,
      baseUrl: process.env.VUE_APP_API_URL,
      checkedCategories: [],
    }
  },
  created() {
    this.$store.dispatch('productCategory/fetchProductCategories')
  },
  watch: {
    isProductFlowEnabled: function (newVal) {
      // watch it
      if (newVal) this.$store.dispatch('productCategory/fetchProductCategories')
      else this.$store.dispatch('experience/fetchExperienceCategories')
    },
  },
  mounted() {
    var resizeEvent = window.document.createEvent('UIEvents')
    resizeEvent.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(resizeEvent)
  },
  methods: {
    check(index) {
      if (this.isProductFlowEnabled) {
        this.$set(this.productCategory.productCategories, index, {
          ...this.productCategory.productCategories[index],
          checked: !this.productCategory.productCategories[index].checked,
        })
        this.productCategory.productCategories.forEach((element, elementIndex) => {
          if (elementIndex !== index) element.checked = false
        });
        if (this.productCategory.productCategories[index]['checked'])
          this.$emit(
            'selected-category',
            this.productCategory.productCategories[index]
          )
        else this.$emit('unselected-category', null)
      } else {
        this.$set(this.experience.experienceCategories, index, {
          ...this.experience.experienceCategories[index],
          checked: !this.experience.experienceCategories[index].checked,
        })
        if (this.experience.experienceCategories[index]['checked'])
          this.$emit(
            'selected-category',
            this.experience.experienceCategories[index]
          )
        else this.$emit('unselected-category', null)
      }
    },
    showCategory() {
      if (this.isProductFlowEnabled)
        this.$store.dispatch('productCategory/fetchProductCategories')
      else this.$store.dispatch('experience/fetchExperienceCategories')
      this.$bvModal.hide('category-modal')
    },
  },
  computed: mapState(['productCategory', 'experience']),
  props: {
    isProductFlowEnabled: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  padding: 10% 5%;
  text-align: center;
  font-weight: 800;
  letter-spacing: 2px;
  color: white;
  text-transform: uppercase;
}

.carousel-3d-slide {
  // height: auto !important;
  background-color: rgba(0, 0, 0, 0.25) !important;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 12px;
  min-width: 100%;
  box-sizing: border-box;
}

.coverImage:nth-child(1) {
  background-image: url('../../assets/static/images/coverImages/slovenia/wineyard.jpg');
}
.coverImage:nth-child(2) {
  background-image: url('../../assets/static/images/coverImages/slovenia/oliveOil.jpg');
}
.coverImage:nth-child(3) {
  background-image: url('../../assets/static/images/coverImages/slovenia/chocolate.jpg');
}
.coverImage:nth-child(4) {
  background-image: url('../../assets/static/images/coverImages/slovenia/workshop.jpg');
}
.coverImage:nth-child(5) {
  background-image: url('../../assets/static/images/coverImages/slovenia/cheese.jpg');
}

.carousel-3d-controls a {
    font-size: 120px !important;
  }

  .carousel-3d-controls {
    color: var(--primary) !important;
  }

@media screen and (max-width: 560px) {
  h2 {
    padding: 25% 15% 5% 15%;
    letter-spacing: 0px;
    font-size: 1.1em;
  }
  .carousel-3d-container figcaption {
    padding: 5px;
    font-size: 12px;
  }
}

label {
  display: inline-block; // to make it easier to click
  color: var(--primary);
  cursor: pointer;
  position: relative; // important

  // Now we'll create the checkbox object

  span {
    display: inline-block;
    position: relative;
    background-color: transparent;
    width: 25px;
    height: 25px;
    transform-origin: center;
    border: none;
    // border-radius: 50%;
    vertical-align: -6px;
    margin-right: 10px;
    transition: background-color 150ms 200ms,
      transform 350ms cubic-bezier(0.78, -1.22, 0.17, 1.89); // custom ease effect for bouncy animation

    // Now we'll create the "tick" using pseudo elements - those will be basically two lines that will be rotated to form the "tick"

    &:before {
      content: '';
      width: 0px;
      height: 2px;
      border-radius: 2px; // so that the tick has nice rounded look
      background: #fff;
      position: absolute;
      transform: rotate(45deg);
      top: 13px; // you'll need to experiment with placement depending on the dimensions you've chosen
      left: 9px; // you'll need to experiment with placement depending on the dimensions you've chosen
      transition: width 50ms ease 50ms;
      transform-origin: 0% 0%;
    }

    &:after {
      content: '';
      width: 0;
      height: 2px;
      border-radius: 2px; // so that the tick has nice rounded look
      background: #fff;
      position: absolute;
      transform: rotate(305deg);
      top: 16px; // you'll need to experiment with placement depending on the dimensions you've chosen
      left: 10px; // you'll need to experiment with placement depending on the dimensions you've chosen
      transition: width 50ms ease;
      transform-origin: 0% 0%;
    }
  }
  // Time to add some life to it

  &:hover {
    span {
      &:before {
        width: 5px;
        transition: width 100ms ease;
      }

      &:after {
        width: 10px;
        transition: width 150ms ease 100ms;
      }
    }
  }
}

.checkbox {
  position: absolute;
  top: 0;
  right: 0;
}

h2 {
  position: absolute;
  top: 25%;
}

input[type='checkbox'] {
  display: none; // hide the system checkbox

  // Let's add some effects after the checkbox is checked

  &:checked {
    + label {
      span {
        background-color: #fff;
        transform: scale(1.25); // enlarge the box

        &:after {
          width: 10px;
          background: #1790b5;
          transition: width 150ms ease 100ms; // enlarge the tick
        }

        &:before {
          width: 5px;
          background: #1790b5;
          transition: width 150ms ease 100ms; // enlarge the tick
        }
      }

      &:hover {
        // copy the states for onMouseOver to avoid flickering
        span {
          background-color: #fff;
          transform: scale(1.25); // enlarge the box

          &:after {
            width: 10px;
            background: #1790b5;
            transition: width 150ms ease 100ms; // enlarge the tick
          }

          &:before {
            width: 5px;
            background: #1790b5;
            transition: width 150ms ease 100ms; // enlarge the tick
          }
        }
      }
    }
  }
}
</style>